export default (apiMethods, endpoints) => ({
  getDomainsAndCategories: () => {
      return apiMethods.get(endpoints.GET_DOMAINS_AND_CATEGORIES_ENDPOINT);
  },
  updateCategory: (category) => {

      let formdata = new FormData();
      formdata.append('name', category.name);
      formdata.append('sortIndex', category.sortIndex)
      if(category.acceptedUploadPicture)
          formdata.append('categoryPicture', category.acceptedUploadPicture);
      return apiMethods.put(endpoints.UPDATE_CATEGORY_ENDPOINT(category.id), formdata, {
          'Content-Type': 'multipart/form-data'
      });
  },
  deleteCategory: (categoryId) => {
    return apiMethods.delete(endpoints.DELETE_CATEGORY_ENDPOINT(categoryId))
  },
  deleteNotificationsCategory: (categoryId) => {
    return apiMethods.delete(endpoints.DELETE_NOTIFICATIONS_CATEGORY_ENDPOINT(categoryId))
  },
  addDomainCategory: (data) => {

    let formdata = new FormData();
    formdata.append('domainId', data.domainId)
    formdata.append('sortIndex', data.sortIndex)
    formdata.append('name', data.name);
    formdata.append('parent', data.parent);
    if(data.image) {
        formdata.append('categoryPicture', data.image)
    }
    return apiMethods.post(endpoints.ADD_DOMAIN_CATEGORY_ENDPOINT, formdata, {
        'Content-Type': 'multipart/form-data'
    })

  },
  addNotificationCategory: (data) => {
    return apiMethods.post(endpoints.ADD_NOTIFICATION_CATEGORY_ENDPOINT, data)
  }
})



// WEBPACK FOOTER //
// ./src/lib/api-domains-admin.js